import Character from "../game/Character";
import Enemy from "../game/Enemy";
import Hero from "../game/Hero";


export const defaultHero = new Hero ({
  name: "Hero",
  hp: { cur: 20, max: 20 },
  mp: { cur: 5, max: 5 },
  ap: { cur: 5, max: 5 },
  attack: 1,
  defense: 1,
});

export const enemies = [
  new Enemy ({
    name: "Green Slime",
    id: "greenSlime",
    hp: { cur: 10, max: 10 },
    mp: { cur: 1, max: 1 },
    ap: { cur: 1, max: 1 },
    attack: 1,
    defense: 1,
  }),
  new Character ({
    name: "Yellow Slime",
    "id": "yellowSlime",
    hp: { cur: 20, max: 20 },
    mp: { cur: 1, max: 1 },
    ap: { cur: 1, max: 1 },
    attack: 1,
    defense: 1,
  }),
  new Character ({
    name: "Blue Slime",
    id: "blueSlime",
    hp: { cur: 10, max: 10 },
    mp: { cur: 1, max: 1 },
    ap: { cur: 1, max: 1 },
    attack: 1,
    defense: 3,
  }),
  new Character ({
    name: "Red Slime",
    id: "redSlime",
    hp: { cur: 10, max: 10 },
    mp: { cur: 1, max: 1 },
    ap: { cur: 1, max: 1 },
    attack: 3,
    defense: 1,
  }),
  new Character ({
    name: "King Slime",
    id: "kingSlime",
    hp: { cur: 50, max: 50 },
    mp: { cur: 10, max: 10 },
    ap: { cur: 10, max: 10 },
    attack: 7,
    defense: 5,
  }),
];
